import React from "react";
import { Navigate } from "react-router-dom";

import ListComponent from "../../../../../components/container-empty/components/list/page";
import AddComponent from "../../../../../components/extra-container-empty-2/components/add/page";
import VideosComponent from "../../../../../components/container-empty/components/videos/page";

export const extrasEmptyTwoRoute = [
  {
    path: "list",
    element: <ListComponent />,
  },
  {
    path: "add",
    element: <AddComponent />,
  },
  {
    path: "videos",
    element: <VideosComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/extras/empty-two/add" />,
  },
  {
    path: "edit/:id",
    element: <AddComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/extras/empty-two/add" />,
  },
];
